import React from "react"
import { Link } from "react-router-dom"
import "./Footer.css"

const Footer = () => {
  return (
    <footer className='footer-section'>
      <div className='container'>
        <div className='footer-content'>
          <div className='footer-info'>
            <div className='footer-brand'>
              <div className='footer-logo'>
                <img
                  src={require("../assets/images/cordova-logo-white.png")}
                  alt='Cordova Franchising'
                  className='footer-logo-image'
                />
              </div>
              <p className='footer-description'>
                The proven IT staffing franchise model that's already printing 8
                figures per year.
              </p>
            </div>
          </div>

          <div className='footer-links'>
            <div className='footer-column'>
              <h4>Legal</h4>
              <ul>
                <li>
                  <Link to='/privacy'>Privacy Policy</Link>
                </li>
                <li>
                  <Link to='/terms'>Terms of Service</Link>
                </li>
              </ul>
            </div>

            <div className='footer-column'>
              <h4>Contact</h4>
              <ul>
                <li>Omaha, Nebraska</li>
                <li>vince@cordovafranchising.com</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='footer-bottom'>
          <div className='footer-disclaimer'>
            <p>
              This website is not part of the Facebook website or Facebook Inc.
              Additionally, this website is NOT endorsed by Facebook in any way.
              Facebook is a trademark of Facebook, Inc.
            </p>
          </div>
          <div className='footer-copyright'>
            <p>
              Copyright 2024 - Cordova Franchising LLC | All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
